@if (amountToBePopulated) {
    <div class="mt-1 mb-1">
        <span class="theme-info-i mr-1" class="align-text-top"></span>
        <span>{{ 'PARTY.CASHIER.web.deposit.amount.v2.toMeetStake' | translate: { amount: amount | vnCurrency: currency } }}</span>
    </div>
}
